/** Chave interna de UI. Nunca gravar esse valor como telefone de contato. */
export function conversationKey(contact: { id?: number; contact_id?: number; phone?: string | null; active_channel?: string | null; source_channel?: string | null } | null | undefined): string {
  if (!contact) return '';
  if ((contact.active_channel || contact.source_channel) === 'instagram') {
    const id = Number(contact.contact_id ?? contact.id);
    return Number.isSafeInteger(id) && id > 0 ? `contact:${id}` : '';
  }
  return String(contact.phone || '').replace(/\D/g, '');
}

export function conversationContactId(key: string): number | null {
  if (!/^contact:[1-9]\d*$/.test(key)) return null;
  const id = Number(key.slice(8));
  return Number.isSafeInteger(id) ? id : null;
}

export function conversationEventKey(event: any): string {
  const payload = event?.data || event || {};
  return conversationKey({
    contact_id: payload.contact_id ?? event?.contact_id,
    phone: payload.phone ?? event?.phone,
    source_channel: payload.source_channel ?? event?.source_channel,
    active_channel: payload.active_channel ?? event?.active_channel,
  });
}
